import { BasicProps } from "components/types/BasicProps";
import { INft } from "logic/types/nft/INft";
import { FC, useEffect, useMemo, useState } from "react";
import { accountLiterals } from "../literals";
import CtaPrimary from "components/CtaPrimary";
import Image from "next/image";
import { AiOutlineCloseCircle } from "react-icons/ai";

type Props = BasicProps & {
  nfts: INft[];
  onBorrowClick: () => void;
  onRemoveClick: (nft: INft) => void;
};

const { borrowCta, selectedAssetsLabel } = accountLiterals.multipleSelectionBar;

export const MultipleSelectionBar: FC<Props> = (props) => {
  const { nfts, onBorrowClick, onRemoveClick } = props;
  const [isOpen, setOpen] = useState<boolean>(false);

  const icon = useMemo<string>(() => (isOpen ? "-" : "+"), [isOpen]);

  const handleToggleList = () => {
    if (nfts.length > 0) {
      setOpen(!isOpen);
    }
  };

  const areActionsDisabled = useMemo<boolean>(() => nfts.length === 0, [nfts]);

  useEffect(() => {
    if (nfts.length === 0) {
      setOpen(false);
    }
  }, [nfts.length]);

  return (
    <div className="fixed bottom-0 left-0 min-h-[100px] w-full bg-secondary px-[100px] py-[30px] flex justify-between">
      <div className="w-full flex flex-col gap-[15px]">
        <div
          className="flex gap-1 items-center text-2xl font-bold"
          onClick={handleToggleList}
        >
          <span>{selectedAssetsLabel(nfts.length)}</span>
          {nfts.length > 0 && (
            <span className="w-[14px] text-center text-uyellow">{icon}</span>
          )}
        </div>
        {isOpen && (
          <div className="w-full h-full px-6 flex flex-col gap-5">
            <ul className="w-full h-full min-h-[48px] flex flex-wrap overflow-y-scroll scrollbar-selected">
              {nfts.map((nft) => (
                <li
                  className="h-10 relative mt-1 w-fit flex justify-center"
                  key={nft.alt}
                >
                  <AiOutlineCloseCircle
                    className="absolute -top-1 -right-1 z-10 cursor-pointer bg-white rounded-full text-black"
                    onClick={() => onRemoveClick(nft)}
                  />
                  <Image
                    className="mt-1 mr-1 h-full w-fit rounded-lg"
                    src={nft.image}
                    width={40}
                    height={40}
                    alt={nft.alt}
                  />
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
      <div className="flex justify-center items-center gap-[15px]">
        <CtaPrimary
          className="w-[130px]"
          disabled={areActionsDisabled}
          onClick={onBorrowClick}
        >
          {borrowCta}
        </CtaPrimary>
      </div>
    </div>
  );
};
